import { render, staticRenderFns } from "./BlocoVisaoGeral.vue?vue&type=template&id=0c59cda2&scoped=true&lang=pug"
import script from "./BlocoVisaoGeral.vue?vue&type=script&lang=js"
export * from "./BlocoVisaoGeral.vue?vue&type=script&lang=js"
import style0 from "./BlocoVisaoGeral.vue?vue&type=style&index=0&id=0c59cda2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c59cda2",
  null
  
)

export default component.exports